export const CertificateText = {
    Certificates: {
        en: "Certificates",
        mr: "प्रमाणपत्रे",
    },
    AllPrograms: {
        en: "All programs",
        mr: "वैयक्तिक वित्त",
    },
    Logout: {
        en: "Log Out",
        mr: "लॉगआउट करा",
    },
    NoCertificate: {
        en: "No Certificate Found!",
        mr: "कोणतेही प्रमाणपत्र सापडले नाही!",
    },
    NoCertificateDes: {
        en: "There is no certificate assigned for you at the moment.",
        mr: "सध्या तुमच्यासाठी कोणतेही प्रमाणपत्र नियुक्त केलेले नाही.",
    },
    checkAgainLbl: {
        en: "Check Again",
        mr: "पुन्हा तपासा",
    },
};
